import type { ItemInventaire, RelationInventaire } from './inventaire-types.ts'

type Ressources = Array<{ cle?: string; nom: string }>

export function liensInventaireDuFlux(
  ressources: Ressources,
  articles: ItemInventaire[],
  relations: RelationInventaire[],
) {
  const cles = new Set(ressources.flatMap((r) => r.cle ? [r.cle] : []))
  const ids = new Set(articles.filter((a) => a.fiche.ressource_cle && cles.has(a.fiche.ressource_cle)).map((a) => a.id))
  return relations.filter((r) => ids.has(r.item_a) || ids.has(r.item_b)).map((relation) => ({
    ...relation,
    salle_a: articles.find((a) => a.id === relation.item_a),
    salle_b: articles.find((a) => a.id === relation.item_b),
  }))
}

export function sallesLieesInventaire(
  ressources: Ressources,
  articles: ItemInventaire[],
  relations: RelationInventaire[],
): string[] {
  const liees = new Set(liensInventaireDuFlux(ressources, articles, relations)
    .flatMap((r) => [r.salle_a?.fiche.ressource_cle, r.salle_b?.fiche.ressource_cle]))
  return ressources.flatMap((r) => r.cle && liees.has(r.cle) ? [r.cle] : [])
}

export function LiensSallesInventaire({ ressources, articles, relations, onInventaire }: {
  ressources: Ressources
  articles: ItemInventaire[]
  relations: RelationInventaire[]
  onInventaire?(id: string): void
}) {
  const liens = liensInventaireDuFlux(ressources, articles, relations)
  if (!liens.length) return null
  return <section class="lsi-resume" aria-label="Disponibilités liées dans l’inventaire">
    <style>{`.lsi-resume{border:1px solid #e5dbe9;border-radius:13px;padding:17px;margin:18px 0;background:#faf7fb}.lsi-resume h4{margin:0 0 10px;font-size:14px}.lsi-resume p{font-size:12px;line-height:1.6;color:#615667}.lsi-resume ul{list-style:none;margin:13px 0 0;padding:0;display:grid;gap:12px}.lsi-resume li{padding:12px;border:1px solid #e5dbe9;border-radius:9px;background:#fff;display:grid;gap:7px}.lsi-resume li>strong{font-size:12px;overflow-wrap:anywhere}.lsi-resume li>small{font-size:11px;color:#615667}.lsi-actions{display:flex;flex-wrap:wrap;gap:6px 14px}.lsi-actions button{border:0;background:none;color:#0071e3;padding:5px 0;min-height:30px;font:inherit;font-size:11px;text-align:left;cursor:pointer}`}</style>
    <h4>Disponibilités liées dans l’inventaire</h4>
    <p>Ces liens s’appliquent à tous les flux qui utilisent ces salles. Réserver l’une rend l’autre indisponible, et inversement. Modifiez-les dans les fiches d’inventaire.</p>
    <ul>{liens.map((lien) => <li key={lien.id}>
      <strong>{lien.salle_a?.fiche.nom ?? 'Salle liée'} ↔ {lien.salle_b?.fiche.nom ?? 'Salle liée'}</strong>
      <small>{lien.mode === 'journee' ? 'Blocage pour la journée entière' : 'Blocage pendant les heures qui se chevauchent'}</small>
      {onInventaire ? <div class="lsi-actions">
        {lien.salle_a ? <button type="button" onClick={() => onInventaire(lien.item_a)}>Ouvrir {lien.salle_a.fiche.nom} ↗</button> : null}
        {lien.salle_b ? <button type="button" onClick={() => onInventaire(lien.item_b)}>Ouvrir {lien.salle_b.fiche.nom} ↗</button> : null}
      </div> : null}
    </li>)}</ul>
  </section>
}
